import { NgModule } from '@angular/core';
import { GenericCriteriaComponent } from './generic-criteria/generic-criteria.component';
import { GenericCriteriaDpComponent } from './generic-criteria-dp/generic-criteria-dp.component';
import {CommonModule} from '@angular/common';
import {SurfDPAddBarModule} from '@surf/surf-dp-add-bar';
import {SurfPaxSelectionModule} from '@surf/surf-pax-selection';
import {SurfComponentsCoreModule} from '@surf/surf-components-core';
import {SurfTypeAheadModule} from '@surf/surf-type-ahead';
import {SurfDropDownModule} from '@surf/surf-drop-down';
import {SurfCalendarModule} from '@surf/surf-calendar';
import {SurfDatePickerModule} from '@surf/surf-date-picker';
import {SurfMultiFieldInputModule} from '@surf/surf-multi-field-input';
import {SurfMultiSelectorDropDownModule} from "@surf/surf-multi-selector-drop-down";

@NgModule({
  declarations: [GenericCriteriaComponent, GenericCriteriaDpComponent],
  imports: [
    CommonModule,
    SurfDPAddBarModule,
    SurfPaxSelectionModule,
    SurfComponentsCoreModule,
    SurfTypeAheadModule,
    SurfDropDownModule,
    SurfCalendarModule,
    SurfMultiFieldInputModule,
    SurfDatePickerModule,
    SurfMultiSelectorDropDownModule
  ],
  exports: [
    GenericCriteriaDpComponent
  ]
})
export class SurfGenericCriteriaModule { }
